<!-- 面包碎组件 -->
<template>
  <div class="breadcrumb-container">
    <el-button
      size="mini"
      icon="el-icon-back"
      class="page-back-btn search-btn btn-primary"
      @click="goback()"
      v-if="canBackHistory"
    ></el-button>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>您当前的位置： 企业管理平台</el-breadcrumb-item>
      <el-breadcrumb-item :key="index" v-for="(item, index) in routeList">{{ item.name }}</el-breadcrumb-item>
      <el-breadcrumb-item v-if="pageTitle">{{pageTitle}}</el-breadcrumb-item>
    </el-breadcrumb>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: ["canBackHistory", "pageTitle","ReturnUrl"],
  data() {
    return {
      routeList: []
    };
  },
  created() {
    this.initial();
  },
  mounted() {},
  watch: {},
  methods: {
    initial() {
      if (this.$route.matched) {
        let tempList = this.$route.matched;
        for (let index = 0; index < tempList.length; index++) {
          let element = tempList[index];
          if (element.parent != undefined) {
            this.routeList.push(element);
          }
        }
      }
    },
    goback() {
      if(this.ReturnUrl){
         this.$router.push(this.ReturnUrl);
      }else{
        window.history.back();
      }
      
      // this.$router.back();
    }
  }
};
</script>
<style lang="less" scoped>
.breadcrumb-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
.el-breadcrumb {
  font-size: 15px;
}
</style>
